interface FormConfiguration {
    [key: string]: Array<{
        label: string;
        value: string;
        fieldType: 'info' | 'suprafata' | 'taxa';
        type?: string;
        isCheckboxField?: boolean;
    }>;
}

export interface IOrar {
    id: number,
    type: number | null,
    cerere_id: number,
    day: number,
    inchis: number,
    nonstop: number,
    from: string | null,
    stop: string | null,
    created_at: Date,
    updated_at: Date,
}

export const formConfigurations: FormConfiguration = {
    'autorizatie-alimentatie-publica': [
        // info
        { label: 'Unitate alimentație publică', value: 'unitate_alimentatie_publica', fieldType: 'info' },
        { label: 'Acord de proprietate', value: 'acord_proprietate', fieldType: 'info', type: 'acord_proprietate' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
        { label: 'Restaurante', value: 'restaurante', fieldType: 'info', type: 'boolean' },
        { label: 'Baruri', value: 'baruri', type: 'boolean', fieldType: 'info' },

        { label: 'Act deținere spațiu', value: 'act_detinere_spatiu', fieldType: 'info', type: 'act_detinere_spatiu' },
        { label: 'Nr. act deținere spațiu', value: 'act_detinere_nr', fieldType: 'info' },
        { label: 'Dată act deținere spațiu', value: 'act_detinere_date', fieldType: 'info', type: 'date' },
        { label: 'Deținere act adițional', value: 'act_detinere_act_aditional', fieldType: 'info', type: 'boolean' },
        { label: 'Nr. act adițional', value: 'act_detinere_act_aditional_nr', fieldType: 'info' },
        { label: 'Dată act adițional', value: 'act_detinere_act_aditional_data', fieldType: 'info', type: 'date' },

        // suprafata
        { label: 'Suprafață totală', value: 'suprafata_spatiu', fieldType: 'suprafata' },
        { label: 'Suprafață de servire', value: 'suprafata_spatiu_servitude', fieldType: 'suprafata' },
        { label: 'Suprafață de pregătire', value: 'suprafata_spatiu_pregatire', fieldType: 'suprafata' },
        { label: 'Suprafață de depozitare', value: 'suprafata_spatiu_depozitare', fieldType: 'suprafata' },
        { label: 'Suprafață anexe, utilități', value: 'suprafata_spatiu_anexe_utilitati', fieldType: 'suprafata' },

        // taxa
        { label: 'Plată Taxă', value: 'dovada_plata_taxa', fieldType: 'taxa', type: 'plata_taxa' },
        { label: 'Număr', value: 'dovada_plata_taxa_nr', fieldType: 'taxa' },
        { label: 'Dată', value: 'dovada_plata_taxa_date', fieldType: 'taxa' },
        { label: 'Valoare', value: 'dovada_plata_taxa_value', fieldType: 'taxa' },
        { label: 'Observații', value: 'dovada_plata_taxa_obs', fieldType: 'taxa' },
    ],
    'acord-de-functionare': [
        // info
        { label: 'Activități CAEN', value: 'activitati_caen', fieldType: 'info' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
        { label: 'Creat la', value: 'created_at', fieldType: 'info', type: 'date' },
        { label: 'Modificat la', value: 'updated_at', fieldType: 'info', type: 'date' },
    ],
    'aviz-orar': [
        // info
        { label: 'Activități CAEN', value: 'activitati_caen', fieldType: 'info' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
    ],
    'modificare-aviz-orar': [
        // info
        { label: 'Număr acord', value: 'numar_acord', fieldType: 'info' },
        { label: 'Dată acord', value: 'data_acord', fieldType: 'info', type: 'date' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
    ],
    'autorizatie-recreative': [
        // info
        { label: 'Activități CAEN', value: 'activitati_caen', fieldType: 'info' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
        { label: 'Act deținere spațiu', value: 'act_detinere_spatiu', fieldType: 'info', type: 'act_detinere_spatiu' },
        { label: 'Nr. act deținere spațiu', value: 'act_detinere_nr', fieldType: 'info' },
        { label: 'Dată act deținere spațiu', value: 'act_detinere_date', fieldType: 'info', type: 'date' },
        { label: 'Deținere act adițional', value: 'act_detinere_act_aditional', fieldType: 'info', type: 'boolean' },
        { label: 'Nr. act adițional', value: 'act_detinere_act_aditional_nr', fieldType: 'info' },
        { label: 'Dată act adițional', value: 'act_detinere_act_aditional_data', fieldType: 'info', type: 'date' },
        { label: 'Suprafață', value: 'suprafata_spatiu_v2', fieldType: 'info' },

        // taxa
        { label: 'Plată Taxă', value: 'dovada_plata_taxa', fieldType: 'taxa', type: 'plata_taxa' },
        { label: 'Număr', value: 'dovada_plata_taxa_nr', fieldType: 'taxa' },
        { label: 'Dată', value: 'dovada_plata_taxa_date', fieldType: 'taxa' },
        { label: 'Valoare', value: 'dovada_plata_taxa_value', fieldType: 'taxa' },
        { label: 'Observații', value: 'dovada_plata_taxa_obs', fieldType: 'taxa' },
    ],
    'autorizatie-piata': [
        // info
        { label: 'Formă organizare', value: 'forma_organizare', fieldType: 'info' },
        { label: 'Denumire piață/târg', value: 'denumire_institutie', fieldType: 'info' },
        { label: 'Tip administrare piață', value: 'tip_piata', fieldType: 'info' },
        { label: 'Număr HCL', value: 'hcl_numar', fieldType: 'info' },
        { label: 'Dată HCL', value: 'hcl_valabilitate', fieldType: 'info', type: 'date' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
    ],
    'alte-sugestii': [
        // info
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
    ],
    'modificare-autorizatie-alimentatie-publica': [
        // info
        { label: 'Nr. autorizație', value: 'numar_acord', fieldType: 'info' },
        { label: 'Dată autorizație', value: 'data_acord', fieldType: 'info', type: 'date' },
        { label: 'Unitate alimentație publică', value: 'unitate_alimentatie_publica', fieldType: 'info' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },

        { label: 'Act deținere spațiu', value: 'act_detinere_spatiu', fieldType: 'info', type: 'act_detinere_spatiu' },
        { label: 'Nr. act deținere spațiu', value: 'act_detinere_nr', fieldType: 'info' },
        { label: 'Dată act deținere spațiu', value: 'act_detinere_date', fieldType: 'info', type: 'date' },
        { label: 'Deținere act adițional', value: 'act_detinere_act_aditional', fieldType: 'info', type: 'boolean' },
        { label: 'Nr. act adițional', value: 'act_detinere_act_aditional_nr', fieldType: 'info' },
        { label: 'Dată act adițional', value: 'act_detinere_act_aditional_data', fieldType: 'info', type: 'date' },
    ],
    'modificare-autorizatie-recreative': [
        // info
        { label: 'Nr. autorizație', value: 'numar_acord', fieldType: 'info' },
        { label: 'Dată autorizație', value: 'data_acord', fieldType: 'info', type: 'date' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },

        { label: 'Act deținere spațiu', value: 'act_detinere_spatiu', fieldType: 'info', type: 'act_detinere_spatiu' },
        { label: 'Nr. act deținere spațiu', value: 'act_detinere_nr', fieldType: 'info' },
        { label: 'Dată act deținere spațiu', value: 'act_detinere_date', fieldType: 'info', type: 'date' },
        { label: 'Deținere act adițional', value: 'act_detinere_act_aditional', fieldType: 'info', type: 'boolean' },
        { label: 'Nr. act adițional', value: 'act_detinere_act_aditional_nr', fieldType: 'info' },
        { label: 'Dată act adițional', value: 'act_detinere_act_aditional_data', fieldType: 'info', type: 'date' },
    ],
    'acord-terase-sezoniere': [
        // info
        { label: 'Nr. autorizație', value: 'numar_acord', fieldType: 'info' },
        { label: 'Dată autorizație', value: 'data_acord', fieldType: 'info', type: 'date' },
        { label: 'Unitate alimentație publică', value: 'unitate_alimentatie_publica', fieldType: 'info' },
        { label: 'Acord de proprietate', value: 'acord_proprietate', fieldType: 'info', type: 'acord_proprietate' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
        { label: 'Restaurante', value: 'restaurante', fieldType: 'info', type: 'boolean' },
        { label: 'Baruri', value: 'baruri', type: 'boolean', fieldType: 'info' },

        // suprafata
        { label: 'Suprafață totală (Unitate + Terasă)', value: 'suprafata_spatiu_v3', fieldType: 'suprafata' },
        { label: 'Suprafață terasă', value: 'suprafata_terasa', fieldType: 'suprafata' },
        { label: 'Nr. locuri terasă', value: 'numar_locuri_terasa', fieldType: 'suprafata' },
        { label: 'Total nr. locuri (Unitate + Terasă)', value: 'suprafata_numar_locuri_terasa', fieldType: 'suprafata' },
    ],
    'reinnoire-autorizatie-alimentatie-publica': [
        // info
        { label: 'Nr. autorizație', value: 'numar_acord', fieldType: 'info' },
        { label: 'Dată eliberare autorizație', value: 'data_acord', fieldType: 'info', type: 'date' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },

        // taxa
        { label: 'Plată Taxă', value: 'dovada_plata_taxa', fieldType: 'taxa', type: 'plata_taxa' },
        { label: 'Număr', value: 'dovada_plata_taxa_nr', fieldType: 'taxa' },
        { label: 'Dată', value: 'dovada_plata_taxa_date', fieldType: 'taxa' },
        { label: 'Valoare', value: 'dovada_plata_taxa_value', fieldType: 'taxa' },
        { label: 'Observații', value: 'dovada_plata_taxa_obs', fieldType: 'taxa' },
    ],
    'autorizatie-activitati-mixte': [
        // info
        { label: 'Denumire comercială a unității', value: 'denumire_comerciala', fieldType: 'info' },
        { label: 'Acord de proprietate', value: 'acord_proprietate', fieldType: 'info', type: 'acord_proprietate' },
        { label: 'Activități CAEN', value: 'activitati_caen', fieldType: 'info' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },

        { label: 'Act deținere spațiu', value: 'act_detinere_spatiu', fieldType: 'info', type: 'act_detinere_spatiu' },
        { label: 'Nr. act deținere spațiu', value: 'act_detinere_nr', fieldType: 'info' },
        { label: 'Dată act deținere spațiu', value: 'act_detinere_date', fieldType: 'info', type: 'date' },
        { label: 'Deținere act adițional', value: 'act_detinere_act_aditional', fieldType: 'info', type: 'boolean' },
        { label: 'Nr. act adițional', value: 'act_detinere_act_aditional_nr', fieldType: 'info' },
        { label: 'Dată act adițional', value: 'act_detinere_act_aditional_data', fieldType: 'info', type: 'date' },

        // suprafata
        { label: 'Suprafață totală', value: 'suprafata_spatiu', fieldType: 'suprafata' },
        { label: 'Număr de locuri', value: 'numar_locuri', fieldType: 'suprafata' },

        // taxa
        { label: 'Plată Taxă', value: 'dovada_plata_taxa', fieldType: 'taxa', type: 'plata_taxa' },
        { label: 'Număr', value: 'dovada_plata_taxa_nr', fieldType: 'taxa' },
        { label: 'Dată', value: 'dovada_plata_taxa_date', fieldType: 'taxa' },
        { label: 'Valoare', value: 'dovada_plata_taxa_value', fieldType: 'taxa' },
        { label: 'Observații', value: 'dovada_plata_taxa_obs', fieldType: 'taxa' },
    ],
    'modificare-autorizatie-activitati-mixte': [
        // info
        { label: 'Nr. autorizație', value: 'numar_acord', fieldType: 'info' },
        { label: 'Dată eliberare autorizație', value: 'data_acord', fieldType: 'info', type: 'date' },
        { label: 'Activități CAEN', value: 'activitati_caen', fieldType: 'info' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },
    ],
    'reinnoire-autorizatie-activitati-mixte': [
        // info
        { label: 'Nr. autorizație', value: 'numar_acord', fieldType: 'info' },
        { label: 'Dată eliberare autorizație', value: 'data_acord', fieldType: 'info', type: 'date' },
        { label: 'Observații', value: 'observatii', fieldType: 'info' },

        // taxa
        { label: 'Plată Taxă', value: 'dovada_plata_taxa', fieldType: 'taxa', type: 'plata_taxa' },
        { label: 'Număr', value: 'dovada_plata_taxa_nr', fieldType: 'taxa' },
        { label: 'Dată', value: 'dovada_plata_taxa_date', fieldType: 'taxa' },
        { label: 'Valoare', value: 'dovada_plata_taxa_value', fieldType: 'taxa' },
        { label: 'Observații', value: 'dovada_plata_taxa_obs', fieldType: 'taxa' },
    ],
};